module.exports = __webpack_public_path__ + "static/img/image-upload@2x.c2bfe00d.png";